export default function capitalize(str: any, everyWord = false): string {
	if (typeof str !== 'string') {
		return str
	} else if (everyWord) {
		return str
			.split(' ')
			.map((word) => capitalize(word, false))
			.join(' ')
	} else {
		const firstLetter = str.charAt(0)
		const rest = str.slice(1)
		return firstLetter.toLocaleUpperCase() + rest
	}
}
